<template>
  <div id="app" :class="currentTheme">
    <transition name="slide-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  props: ['theme'],
  computed: {
    buildSlides () {
      return this.$store.state.allSlides
    },
    currentTheme () {
      if (this.$route.query.theme === '80s80s' || this.$route.query.theme === '90s90s' || this.$route.query.theme === '1deutsch') {
        return 'theme-' + this.$route.query.theme
      } else {
        return this.$route.query.theme ? this.$route.query.theme : this.$route.params.display
      }
    }
  },
  created () {
    const self = this
    self.$store.dispatch('loadConfig', this.$route.params.display)
      .then(() => {
        self.$store.dispatch('showNextSlide')

        // slide interval
        self.slideInt = setInterval(self.intervalMethod, self.$store.state.slideTimeout)

        // stop slides and naviagate via arrow keys
        window.addEventListener('keydown', this.keyCodes, false)
      })
  },
  methods: {
    intervalMethod (event) {
      if (!document.hidden) {
        this.$store.dispatch('showNextSlide')
      }
    },
    keyCodes (event) {
      /* space = stop / restart slide interval */
      if (event.keyCode === 32) {
        if (this.slideInt) {
          clearInterval(this.slideInt)
          this.slideInt = null
        } else {
          this.slideInt = setInterval(this.intervalMethod, this.$store.state.slideTimeout)
          this.$store.dispatch('showNextSlide')
        }
      } else if (event.keyCode === 39 && this.slideInt === null) {
        this.$router.forward()
      } else if (event.keyCode === 37 && this.slideInt === null) {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="postcss" src="./assets/css/main.css"></style>



// WEBPACK FOOTER //
// src/App.vue